export default "__VITE_ASSET__CZu53pyM__"